import React from 'react';
type ProductNameProps = {
  script?: boolean;
  accentClassName?: string;
};
export function ProductName({
  script = false,
  accentClassName = 'text-primary'
}: ProductNameProps) {
  return <>
      Stretching{' '}
      <span className={`${script ? 'font-display font-semibold' : ''} italic ${accentClassName}`} data-id="element-282" data-mp="pn6zms30vb7p">
        Instructor Ready
      </span>
    </>;
}